<template>
	<b-row class="formulario-row">
		<b-col cols="12">
			<div class="formulario-block-title"><h5>{{ labels.titulo }}</h5></div>
			<div class="admin-table-block mt-4">
				<CorporateDataTable
					:items="listFlujos"
					:fields="allFields"
					:filter-defs="tableFilterDefs"
					:labels="tableLabels"
					:default-per-page="50"
					:page-options="[10, 20, 50, 100]"
					:narrow="false"
					:table-min-height="500"
					:table-max-height="500"
				>
					<template #toolbar-actions>
						<button class="btn-save" @click="saveData">{{ labels.asignar }}</button> 
					</template>
					<template #cell(valor_1)="data">
						<div v-if="data.item.valor_1">
						<input type="number" v-model="data.item.valor_1">
						</div>
					</template>
					<template #cell(valor_2)="data">
						<div v-if="data.item.valor_2">
						<input type="number" v-model="data.item.valor_2">
						</div>
					</template>
					<template #cell(valor_3)="data">
						<div v-if="data.item.valor_3">
						<input type="number" v-model="data.item.valor_3">
						</div>
					</template>
				</CorporateDataTable>
			</div>
		</b-col>
	</b-row>
</template>

<script>
import CorporateDataTable from "../utils/CorporateDataTable.vue"
export default {
name: 'ModFlujosContrato',
components: {
        CorporateDataTable,
},
props: ['modFlujosContrato', 'aFlujosContrato', 'valor_canon', 'numero_cuotas'],
data: () => ({
	listFlujos: [],
}),
computed: {
labels() {
	if (this.$store.state._language === "es-ES") { 
		return {
			title: 'Flujos del Contrato',
			asignar: 'Aceptar',
			close: 'Cerrar',
			cuota: 'Cuota',
			valor: 'Valor',
			titulo: "Flujos",
			cuota1: "Cuota",
			valor1: "Valor",
			cuota2: "Cuota",
			valor2: "Valor",
			cuota3: "Cuota",
			valor3: "Valor",
		}
	} else {
		return {
			title: 'Add cost center',
			asignar: 'Assign',
			close: 'Close',
			cuota: 'Cuota',
			valor: 'Value',
		}
	}

},
allFields() {
      return [
        { key: 'cuota_1', label: this.labels.cuota1, sortable: false },
        { key: 'valor_1', label: this.labels.valor1, sortable: false },
        { key: 'cuota_2', label: this.labels.cuota2, sortable: false },
        { key: 'valor_2', label: this.labels.valor2, sortable: false },
        { key: 'cuota_3', label: this.labels.cuota3, sortable: false },
        { key: 'valor_3', label: this.labels.valor3, sortable: false },
      ];
    },
tableFilterDefs() {
      return [
      ];
    },
tableLabels() {
      return {
        noRow: this.labels.empty,
        noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
        noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
        sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
        showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
        filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
        clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
      };
    }
  },
  methods: {
    cierraModal() {
      this.$emit('cierraModalFC', false)
    },
    saveData() {
      // Transformar los datos al formato esperado por el padre
      const datosFinales = this.listFlujos.flatMap(fila => {
        const items = []
        for (let i = 1; i <= 3; i++) {
          if (fila[`cuota_${i}`]) {
            items.push({
              cuota: fila[`cuota_${i}`],
              valor: fila[`valor_${i}`]
            })
          }
        }
        return items
      })
      
      this.$emit('flujosContratoFC', datosFinales)
      this.$toast.success('Flujo Asignado.')
    },
    procesarDatos() {
      const chunkSize = 3
      this.listFlujos = []
      
      for (let i = 0; i < this.aFlujosContrato.length; i += chunkSize) {
        const chunk = this.aFlujosContrato.slice(i, i + chunkSize)
        const fila = {}
        
        chunk.forEach((item, idx) => {
          const pos = idx + 1
          fila[`cuota_${pos}`] = item.cuota
          fila[`valor_${pos}`] = item.valor_cuota || item.valor || 0
        })
        
        this.listFlujos.push(fila)
      }
    }
  },
  mounted() {
    this.procesarDatos()
  },
  watch: {
    aFlujosContrato: {
      handler() {
        this.procesarDatos()
      },
      deep: true
    }
  }
}
</script>
